export const API_GET_ALL_LABORATORY = 'API_GET_ALL_LABORATORY'
export const API_GET_ALL_LABORATORY_SUCCESS = 'API_GET_ALL_LABORATORY_SUCCESS'
export const API_GET_ALL_LABORATORY_FAIL = 'API_GET_ALL_LABORATORY_FAIL'

export const API_ADMIN_GET_ALL_LABORATORY = 'API_ADMIN_GET_ALL_LABORATORY'
export const API_ADMIN_GET_ALL_LABORATORY_SUCCESS = 'API_ADMIN_GET_ALL_LABORATORY_SUCCESS'
export const API_ADMIN_GET_ALL_LABORATORY_FAIL = 'API_ADMIN_GET_ALL_LABORATORY_FAIL'

export const API_ADMIN_GET_LABORATORY = 'API_ADMIN_GET_LABORATORY'
export const API_ADMIN_GET_LABORATORY_SUCCESS = 'API_ADMIN_GET_LABORATORY_SUCCESS'
export const API_ADMIN_GET_LABORATORY_FAIL = 'API_ADMIN_GET_LABORATORY_FAIL'

export const API_ADMIN_POST_LABORATORY = 'API_ADMIN_POST_LABORATORY';
export const API_ADMIN_POST_LABORATORY_SUCCESS = 'API_ADMIN_POST_LABORATORY_SUCCESS';
export const API_ADMIN_POST_LABORATORY_FAIL = 'API_ADMIN_POST_LABORATORY_FAIL';

export const API_ADMIN_PATCH_LABORATORY = 'API_ADMIN_PATCH_LABORATORY';
export const API_ADMIN_PATCH_LABORATORY_SUCCESS = 'API_ADMIN_PATCH_LABORATORY_SUCCESS';
export const API_ADMIN_PATCH_LABORATORY_FAIL = 'API_ADMIN_PATCH_LABORATORY_FAIL';

export const API_ADMIN_DELETE_LABORATORY = 'API_ADMIN_DELETE_LABORATORY';
export const API_ADMIN_DELETE_LABORATORY_SUCCESS = 'API_ADMIN_DELETE_LABORATORY_SUCCESS';
export const API_ADMIN_DELETE_LABORATORY_FAIL = 'API_ADMIN_DELETE_LABORATORY_FAIL';

export const ADMIN_INIT_NEW_LABORATORY = 'ADMIN_INIT_NEW_LABORATORY'

export const ADMIN_RESET_FOCUS_LABORATORY = 'ADMIN_RESET_FOCUS_LABORATORY'

export const API_SEARCH_LABORATORY = 'API_SEARCH_LABORATORY'
export const API_SEARCH_LABORATORY_SUCCESS = 'API_SEARCH_LABORATORY_SUCCESS'
export const API_SEARCH_LABORATORY_FAIL = 'API_SEARCH_LABORATORY_FAIL'